import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtentetamir.com.tr web siteniz üzerinden yazıyorum.');

  return (
    <footer style={{ backgroundColor: '#e8e3d9' }} className="text-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center mb-3 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/f860490af8fb2afe82f5ccd4e5e3f508.png"
                alt="İzmir Tente Tamir Logo"
                className="h-[90px] w-auto object-contain"
              />
            </Link>
            <p className="text-xs text-gray-600 mb-3 leading-relaxed">
              İzmir genelinde profesyonel tente tamiri ve yenileme hizmetleri
            </p>
            <div className="flex items-center space-x-3">
              <a
                href={`https://wa.me/905513723512?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
              <a
                href="tel:+905513723512"
                className="w-8 h-8 flex items-center justify-center bg-gray-800 hover:bg-gray-900 text-white rounded-full transition-colors cursor-pointer"
                aria-label="Telefon"
              >
                <i className="ri-phone-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <div className="text-sm font-bold text-gray-900 mb-3 md:mb-4">Hizmetlerimiz</div>
            <ul className="space-y-1.5 md:space-y-2">
              <li>
                <Link to="/hizmetler/tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Tente Tamiri
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/koruklu-tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Körüklü Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/mafsalli-tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Mafsallı Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/branda-degisimi" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Branda Değişimi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/tente-yenileme" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Tente Yenileme
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/manuel-motorlu-tente-servisi" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Manuel ve Motorlu Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/bioklimatik-pergola-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Bioklimatik Pergola
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/otomatik-pergola-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Otomatik Pergola
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/kasetli-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Kasetli Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/t-modul-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  T-Modül Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/zip-perde-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Zip Perde Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/seffaf-stor-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Şeffaf Stor Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/fermuar-seffaf-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Fermuarlı Şeffaf Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/fransiz-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Fransız Tente
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/karpuz-tente" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Karpuz Tente
                </Link>
              </li>
            </ul>
          </div>

          {/* Hizmet Bölgelerimiz */}
          <div>
            <div className="text-sm font-bold text-gray-900 mb-3 md:mb-4">Hizmet Bölgelerimiz</div>
            <ul className="space-y-1.5 md:space-y-2">
              <li>
                <a href="/" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  İzmir Tente Tamir
                </a>
              </li>
              <li>
                <a href="/hizmetler/tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Karabağlar Tente Tamiri
                </a>
              </li>
              <li>
                <a href="/hizmetler/tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Buca Tente Tamiri
                </a>
              </li>
              <li>
                <a href="/hizmetler/tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Bornova Tente Tamiri
                </a>
              </li>
              <li>
                <a href="/hizmetler/tente-tamiri" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Konak Tente Tamiri
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold text-gray-900 mb-3 uppercase tracking-wide">Kurumsal</div>
            <ul className="space-y-1.5 text-xs text-gray-600">
              <li>
                <Link to="/hakkimizda" className="hover:text-gray-900 transition-colors cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-gray-900 transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/kvkk" className="hover:text-gray-900 transition-colors cursor-pointer">
                  KVKK
                </Link>
              </li>
              <li>
                <Link to="/cerez-politikasi" className="hover:text-gray-900 transition-colors cursor-pointer">
                  Çerez Politikası
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold text-gray-900 mb-3 uppercase tracking-wide">İletişim</div>
            <ul className="space-y-1.5 text-xs text-gray-600">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line mt-0.5 text-gray-500"></i>
                <span>Karabağlar / İzmir</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-gray-500"></i>
                <a href="tel:+905513723512" className="hover:text-gray-900 transition-colors cursor-pointer">
                  0551 372 35 12
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-whatsapp-line text-green-500"></i>
                <a
                  href={`https://wa.me/905513723512?text=${whatsappMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-900 transition-colors cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-time-line text-gray-500"></i>
                <span>09:00 - 17:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-300 mt-8 pt-6 flex flex-col md:flex-row items-center justify-between text-xs text-gray-500">
          <p>&copy; {currentYear} İzmir Tente Tamir. Tüm hakları saklıdır.</p>
          <div className="flex items-center space-x-3 mt-3 md:mt-0">
            <Link to="/kvkk" className="hover:text-gray-900 transition-colors cursor-pointer">
              KVKK
            </Link>
            <Link to="/cerez-politikasi" className="hover:text-gray-900 transition-colors cursor-pointer">
              Çerez Politikası
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
